import React from 'react';
import _, { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { convertToUpperCase } from 'helper';

function Information({
  taxpayer,
}) {
  const spanGap = 8;

  return (
    <>
      <div className='px-3' style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  BUSINESS INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Date of Registration
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {moment(_.get(taxpayer, 'date_of_registration')).format('MMMM DD, YYYY') || '--'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Place of Registration
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(
                    taxpayer,
                    'place_of_registration_municipality_name'
                  ) || '--'}
                  ,{' '}
                  {_.get(
                    taxpayer,
                    'place_of_registration_province_name'
                  ) || '--'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                City/Municipality
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>
                  {_.get(taxpayer,
                    'place_of_registration_municipality_name'
                  ) || '--'}
                </b>
              </td>
            </tr>                            
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Business Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>{_.get(taxpayer, 'name_of_corporation_partnership') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Business Nature
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>{_.get(taxpayer, 'nature_of_business_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Business Line
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td>
                <b>{convertToUpperCase(_.get(taxpayer, 'business_line_name'))}</b>
              </td>
            </tr>

            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  PRESIDENT/AUTHORIZED REPRESENTATIVE
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                First Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'authorized_representative_first_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Middle Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'authorized_representative_middle_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Last Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'authorized_representative_last_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Extension Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'authorized_representative_extension_name') || '--'}</b>
              </td>
            </tr>

            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  BUSINESS ADDRESS
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Region
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'region_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Province
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'province_name') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                City/Municipality
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'municipality_name') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Barangay
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'barangay_name')}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Address Line 1
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'street') || '-'}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

Information.defaultProps = {
  taxpayer: {},
};

Information.propTypes = {
  taxpayer: PropTypes.instanceOf(Object),
};

export default Information;
